import { useCallback, useEffect } from 'react'
import { UseModalPaywall } from '../../event/use-modal-paywall'

interface Props {
  isPremium: boolean
  isFree: boolean
  isPro: boolean
  duration?: number | null
  modalPaywall: UseModalPaywall
  trackId: string
  enabled: boolean
}

export const useModalTimeLimitation = ({
  isPremium,
  isFree,
  isPro,
  duration,
  modalPaywall,
  trackId,
  enabled
}: Props): void => {
  const fiveMinutes = 60 * 5
  const twentyMinutes = 60 * 20

  const showPaywallOneTime = useCallback(() => {
    const paywallKey = `paywall-limitation-${trackId}`
    const paywallViewed = localStorage.getItem(paywallKey)

    if (paywallViewed || isPro) return

    if (isFree && duration) {
      if (duration > fiveMinutes && duration < twentyMinutes) {
        localStorage.setItem(paywallKey, 'true')
        modalPaywall.onOpen('time-limitation-premium')
      } else if (duration > twentyMinutes) {
        localStorage.setItem(paywallKey, 'true')
        modalPaywall.onOpen('time-limitation-pro')
      }
    } else if (isPremium && duration && duration > twentyMinutes) {
      localStorage.setItem(paywallKey, 'true')
      modalPaywall.onOpen('time-limitation-pro')
    }
  }, [
    trackId,
    modalPaywall,
    duration,
    fiveMinutes,
    twentyMinutes,
    isFree,
    isPremium,
    isPro
  ])

  useEffect(() => {
    if (trackId && enabled) {
      showPaywallOneTime()
    }
    // eslint-disable-next-line
  }, [trackId, enabled])
}
